export default __webpack_public_path__ + "static/media/Logo bank-of-england.64a50832.png";